import React, { useEffect, createElement } from 'react';
export function GoogleAnalytics() {
  useEffect(() => {
    // Create the async script element for gtag.js
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-LN1YYQ0BV0';
    // Create the inline script element for gtag configuration
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-LN1YYQ0BV0');
    `;
    // Create the Google Analytics click tracking script
    const gaClickTrackingScript = document.createElement('script');
    gaClickTrackingScript.innerHTML = `
      // Detect clicks that lead from landers → main Shopify site
      function isToMainSite(a){
        try {
          return new URL(a.href).hostname.endsWith('irelief.us');
        } catch(e){
          return false;
        }
      }
      document.querySelectorAll('a,button').forEach(el=>{
        el.addEventListener('click', (e)=>{
          const a = e.currentTarget.tagName === 'A' ? e.currentTarget : e.currentTarget.closest('a');
          if (a && isToMainSite(a)) {
            gtag('event', 'cta_click', {
              event_category: 'Engagement',
              event_label: location.hostname
            });
          }
        });
      });
    `;
    // Insert scripts at the beginning of the head
    document.head.insertBefore(gtagScript, document.head.firstChild);
    document.head.insertBefore(inlineScript, document.head.childNodes[1]);
    // Append the tracking script to the end of the body
    document.body.appendChild(gaClickTrackingScript);
    // Cleanup function to remove scripts when component unmounts
    return () => {
      document.head.removeChild(gtagScript);
      if (inlineScript.parentNode) {
        document.head.removeChild(inlineScript);
      }
      if (gaClickTrackingScript.parentNode) {
        document.body.removeChild(gaClickTrackingScript);
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount
  return null; // This component doesn't render anything
}